"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgColors = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M13.45 13.23a6.217 6.217 0 0 1-5.85-1.662 6.2 6.2 0 1 1 5.85 1.662ZM15.148 14.774a8.23 8.23 0 0 0 3.698-3.06c.154-.232.231-.349.33-.407a.51.51 0 0 1 .289-.07c.114.009.212.065.408.176a6.2 6.2 0 0 1-5.567 11.065c-.251-.11-.377-.165-.456-.273a.51.51 0 0 1-.096-.327c.008-.134.103-.276.291-.561a8.156 8.156 0 0 0 1.355-4.494V16.8a8.222 8.222 0 0 0-.252-2.026ZM4.127 11.413c.196-.111.293-.167.408-.175a.51.51 0 0 1 .289.069c.099.058.176.175.33.408a8.193 8.193 0 0 0 8.066 3.595l.006.026c.114.469.174.959.174 1.464v.021a6.2 6.2 0 1 1-9.273-5.408Z", fill: "currentColor" }) }))); };
exports.default = SvgColors;
